/**
 * Zimobi: the lead-distribution notification template is created and sent by
 * the system itself and is never meant to be picked manually by an agent, so it
 * is hidden from every template picker.
 *
 * Templates with dynamic-URL buttons are selectable: since Chatwoot 4.5 the
 * template parser asks for their button parameters. Flow-button templates (the
 * satisfaction survey / NPS) are selectable too: the backend fills the flow
 * button on dispatch (see build_flow_template_body).
 */

// Keep in sync with the backend constant
// Custom::Concerns::Channel::Whatsapp::NotificationLeadDistributionTemplate::NOTIFICATION_LEAD_DISTRIBUTION_TEMPLATE_NAME
export const SYSTEM_TEMPLATE_NAME_PREFIX = 'delivery_confirmation_v';

/**
 * @param {object} template - a WhatsApp message template
 * @returns {boolean} true when the template is sent by the system and must
 *   not be offered for manual selection.
 */
export const isSystemManagedWhatsAppTemplate = template =>
  (template?.name || '').startsWith(SYSTEM_TEMPLATE_NAME_PREFIX);

/**
 * Removes system-managed templates from a list, leaving only the ones an agent
 * can send manually. Non-array input yields an empty array.
 *
 * @param {Array} [templates=[]]
 * @returns {Array}
 */
export const filterSelectableWhatsAppTemplates = (templates = []) =>
  (Array.isArray(templates) ? templates : []).filter(
    template => !isSystemManagedWhatsAppTemplate(template)
  );
